import Vue from "vue"
/* import customersApi from "../../api/customers" */
import utilsApi from "../../api/utils"
const initialObject = {
  _id: undefined,
  first_name: undefined,
  last_name: undefined,
  email: undefined,
  billing_address: {
    first_name: undefined,
    last_name: undefined,
    address: undefined,
    address_extra: undefined,
    post_code: undefined,
    city: undefined,
    country: undefined,
    province: undefined,
    phone: undefined
  },
  shipping_address: {
    first_name: undefined,
    last_name: undefined,
    address: undefined,
    address_extra: undefined,
    post_code: undefined,
    city: undefined,
    country: undefined,
    province: undefined,
    phone: undefined
  },
  document: undefined,
  document_type: undefined,
  subscribe_newsletter: undefined,
  customer_orders: [],
  extra_info: {},
  createdAt: undefined,
  updatedAt: undefined
}
const ignoreObjectsFields = ["createdAt", "updatedAt"]
// general state for the site
const initialState = {
  customers: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}

const state = Object.assign({}, initialState)

const getters = {
  customers: (state) => state.customers,
  customersIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  customersError: (state) => state.error,
  customers_Object: (state) => state.object,
  customers_isNew: (state) => state.isNew,
  customers_selected: (state) => state.selected
}
const actions = {
  async DELETE_customers({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("customers", object)
    if (apiResponse != null) {
      //commit("CUSTOMERS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_customers", state.page)
      return true
    } else {
      commit("CUSTOMERS_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_customers({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_customers", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_customers", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_customersState({ commit }, payload) {
    commit("SET_customers", payload)
    return true
  },
  async UPDATE_customers({ commit, dispatch, state }, object) {
    const filtered = Object.keys(object)
      .filter((key) => !ignoreObjectsFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = object[key]
        return obj
      }, {})
    let apiResponse = await utilsApi.updateObject("customers", filtered)
    if (apiResponse != null) {
      commit("CUSTOMERS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_customers", state.page)
      return true
    } else {
      commit("CUSTOMERS_ERROR")
      return false
    }
  },
  async CREATE_customers({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("customers", object)
    if (apiResponse != null) {
      commit("SET_customers", {
        param: "object",
        value: apiResponse.customer
      })
      dispatch("FETCH_PAGE_customers", state.page)
      return true
    } else {
      commit("CUSTOMERS_ERROR")
      return false
    }
  },
  async FETCH_customers({ commit }) {
    let apiResponse = await utilsApi.getObjects("customers")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("CUSTOMERS_SETTING", apiResponse)
      return true
    } else {
      commit("CUSTOMERS_ERROR")
      return false
    }
  },
  async FETCH_PAGE_customers({ commit }, page) {
    let apiResponse = await utilsApi.getObjectsPage("customers", page)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("CUSTOMERS_SETTING", { ...apiResponse, page })
      return true
    } else {
      commit("CUSTOMERS_ERROR")
      return false
    }
  },

  UPDATE_OBJECT_customers({ commit }, payload) {
    commit("SET_OBJECT_CUSTOMER", payload)
    return true
  },
  CLEAN_OBJECT_customers({ commit }) {
    commit("SET_OBJECT_CUSTOMER_INITIAL")
    return true
  },
  async CLEAN_STORE_customers({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_customers", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  },
  UPDATE_SELECTED_customers({ commit }, payload) {
    commit("SET_SELECTED_CUSTOMERS", payload)
    return true
  },
  UPDATE_STATE_CUSTOMERS({ commit }, payload) {
    commit("SET_customers", payload)
    return true
  }
}
const mutations = {
  CUSTOMERS_SETTING: (state, { customers, count = false, page }) => {
    //console.log(state)
    state.count = count || state.customers.length
    state.page = page || state.page
    state.customers = customers
    state.fetched = true
    state.error = false
  },
  CUSTOMERS_ERROR: (state) => {
    state.customers = null
    state.fetched = true
    state.error = false
  },
  SET_OBJECT_CUSTOMER: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_CUSTOMER_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_SELECTED_CUSTOMERS: (state, selectedProducts) => {
    state.selected = selectedProducts
  },
  SET_customers: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
